import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';


export function getAllLists(){
    return axios.post(BASE_API + 'api/listtypeaudit', null , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}

export function getAllAudit(body){
    return axios.post(BASE_API + 'api/audit', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}